import React, { Component } from 'react'

import ContMessageI18N from '../../containers/ContMessageI18N';
import HelperContext from '../../helpers/HelperContext';

class TestContextLanguage extends Component {

	constructor(props) {
		super(props);
		this.onChange = props.onChange;
		this.theme = props.theme;
	}
	onChange = function (data) { }

	handleChange = name => event => {
		var value = { [name]: event.target.value };
		this.onChange(value);
	};

	getLabel(fieldname, objectname) {
		const objectnamePart = objectname ? `.${objectname}` : '';
		return  this.props.settings.isDevelopperView ? fieldname	
				: this.getMessage(`context${objectnamePart}.${fieldname}`);
	}
	getItemLabel(value, fieldname, objectname) {
		const objectnamePart = objectname ? `.${objectname}` : '';
		return this.getMessage(`context${objectnamePart}.${fieldname}.${value}`, `${value} - `, value);
	}
	getMessage(i18nKey, prefix, optionValue) {
		return <ContMessageI18N i18n={i18nKey} prefix={prefix} optionValue={optionValue} />
	}


	render() {
		return (
			<div className="col-auto">
				<label htmlFor="testScreen-languageCode" className="form-label">{this.getLabel('languageCode')}</label>
				<select className="form-select" id="testScreen-languageCode"
					onChange={this.handleChange('languageCode')} value={this.props.value}>
					{HelperContext.getCompatibleLanguages(this.props.country) != null &&
						HelperContext.getCompatibleLanguages(this.props.country).map((languageCode, index) => (
							<React.Fragment key={index}>{this.getItemLabel(languageCode, 'languageCode')}</React.Fragment>
						))}
				</select>
			</div>
		)
	}
}

export default (TestContextLanguage)
